import { B as BxfFormGroup$1, d as defineCustomElement$1 } from './p-5fbc6d16.js';

const BxfFormGroup = BxfFormGroup$1;
const defineCustomElement = defineCustomElement$1;

export { BxfFormGroup, defineCustomElement };
